module.exports = __webpack_public_path__ + "img/image.d6cf76df.svg";